var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "14px",
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "warning (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Re-link-bank-accounts",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-Re-link-bank-accounts",
    transform: "translate(-305.000000, -409.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(294.500000, 403.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning-(1)",
    transform: "translate(11.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7043469,10.3183462 C15.5772974,10.0000863 15.2163464,9.84505175 14.8980865,9.97210129 C14.5798266,10.0991508 14.4247921,10.4601018 14.5518416,10.7783617 C14.7133605,11.1830277 14.6603999,11.6450598 14.410148,12.0143877 C14.159772,12.3839018 13.7588912,12.5958372 13.3103241,12.5958372 L2.57722861,12.5958372 C2.087925,12.5958372 1.65341247,12.3405281 1.41485718,11.9128102 C1.17592958,11.4843786 1.18716082,10.9795002 1.44488989,10.5621758 L6.81143762,1.87338347 C7.05579468,1.47774593 7.47907597,1.24154858 7.94377633,1.24154858 C8.4084767,1.24154858 8.83172696,1.47774593 9.07611505,1.87338347 L13.0451178,8.29951504 C13.22519,8.59106194 13.6075486,8.68150135 13.8990335,8.50133611 C14.1905493,8.32129496 14.2809577,7.93896738 14.1008545,7.64742048 L10.1318207,1.22128891 C9.65973627,0.456943985 8.84177923,0.000620510571 7.94374531,0.000620510571 C7.04571138,0.000620510571 6.22775435,0.45697501 5.75566991,1.22128891 L0.389122179,9.91011228 C-0.108403197,10.7157212 -0.130059016,11.6903571 0.331135466,12.5172805 C0.791957642,13.3434903 1.63160152,13.8367342 2.57722861,13.8367342 L13.3103241,13.8367342 C14.1771153,13.8367342 14.9524122,13.4261734 15.4374343,12.7104144 C15.9188264,11.9999919 16.0185735,11.1057431 15.7043469,10.3183462 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94405556,11.3859657 C8.28673253,11.3859657 8.56450408,11.1081941 8.56450408,10.7655171 C8.56450408,10.4228402 8.28673253,10.1450686 7.94405556,10.1450686 L7.94374531,10.1450686 C7.60106834,10.1450686 7.32345191,10.4228402 7.32345191,10.7655171 C7.32345191,11.1081941 7.6013786,11.3859657 7.94405556,11.3859657 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56422485,8.59391628 L8.56422485,4.03356692 C8.56422485,3.69088995 8.2864533,3.4131184 7.94377633,3.4131184 C7.60109937,3.4131184 7.32332781,3.69088995 7.32332781,4.03356692 L7.32332781,8.59391628 C7.32332781,8.93659325 7.60109937,9.2143648 7.94377633,9.2143648 C8.2864533,9.2143648 8.56422485,8.93659325 8.56422485,8.59391628 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.0b36bd6ed7cbc016bb27f48fc4ad299a.svg";
export { ForwardRef as ReactComponent };